import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { delay } from 'rxjs/operators';
import { BnNgIdleService } from 'bn-ng-idle';
import Swal from 'sweetalert2';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { RouterExtService } from './service/RouterExtService';
import { LoadingService } from './service/LoadingService';
import { Observable } from 'rxjs';
import { ChangeDetectionStrategy } from '@angular/core';
import { LocalStorageService } from './service/LocalStorageService';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'growtherp';
  isLoading$: Observable<boolean>;

  BUID: string;
  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    routerExtService: RouterExtService,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
  ) {
    this.isLoading$ = this.loadingService.loadingSub.asObservable();
    let showSidebar = true;
    this.router.events.subscribe(() => {
      const hiddenRoutes = ['/home/company'];
      showSidebar = !hiddenRoutes.includes(this.router.url);

      if(document.getElementById('sidebar-menu')!=null)
      if (showSidebar) {
        document.getElementById('sidebar-menu').style.display='block';
      } else {
        document.getElementById('sidebar-menu').style.display='none';
      }
    });
  }

  ngOnInit(): void {
    //60 = 1 minute
    let appTimout=10800;  // 1.5 Minutes
    //let appTimout=1800;  // 30 Minutes
    //let appTimout=500; // 5 Minutes
    //  let appTimout=300; // 3 Minutes
    this.bnIdle.startWatching(appTimout).subscribe((res) => {
      if (res) {
        let href = this.router.url;
        if (!href.toLocaleLowerCase().includes('account')) {
          this.localStorageService.clearData();
          Swal.close();
          Swal.fire(
            'Timed Out!',
            'Your session has timed out and you need to log in again!',
            'warning',
          );
          this.router.navigate(['/account/login']);
        }
        // this.router.navigateByUrl('logout');
      }
    }); 
  }

  @HostListener('document:focusin', ['$event'])
  onFocus(event: FocusEvent) {
    const target = event.target as HTMLElement;
    if (
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement
    ) {
      target.select?.(); // select if it's selectable
    }
  }
}
